export default "__VITE_ASSET__C6lmAHWv__ 584w";